import { Component, OnInit } from '@angular/core';
import { Tier } from '../models/tier';
import { Router, ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';
import { MessageService } from 'primeng/components/common/messageservice';

@Component({
	selector: 'app-tiers',
	templateUrl: './tiers.component.html',
	styleUrls: ['./tiers.component.css']
})

export class TiersComponent implements OnInit
{
	public tiers: Tier[];

	constructor(private route: ActivatedRoute, private router: Router, private messageService: MessageService)
	{
	}

	ngOnInit()
	{

		if (this.route.snapshot.data['tiers'] instanceof Response)
		{
			// Some unhandled error occurred.
			this.tiers = [];

			this.messageService.add({
				severity: 'error',
				summary: 'Fout',
				detail: 'Er is een fout opgetreden tijdens het ophalen van de staffels.'
			});
		}
		else if (this.route.snapshot.data['tiers'] instanceof Array)
		{
			// Data was received.
			this.tiers = this.route.snapshot.data['tiers'];
		}
		else
		{
			// An error occurred but was already handled.
			this.tiers = [];
		}
	}

	public openTier(tier: Tier)
	{
		this.router.navigate(['/staffels', tier.id]);
	}

	public createTier()
	{
		this.router.navigate(['/staffels/aanmaken']);
	}

}



// WEBPACK FOOTER //
// ./src/app/tiers/tiers.component.ts